import {
  FETCH_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST,
  FETCH_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS,
  FETCH_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE,
  FETCH_APPLICATION_HOURS_STATS_PER_MONTH_RESET,
} from "./ApplicationHoursAnalyticsTypes";

const initialApplicationHoursStatsPerMonthState = {
  loading: false,
  error: null,
  applicationHoursStatsPerMonth: []
};

export const fetchApplicationHoursStatsPerMonthReducer = (state = initialApplicationHoursStatsPerMonthState, action) => {
    switch (action.type) {
        case FETCH_APPLICATION_HOURS_STATS_PER_MONTH_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };
        case FETCH_APPLICATION_HOURS_STATS_PER_MONTH_SUCCESS:
            return {
                ...state,
                loading: false,
                applicationHoursStatsPerMonth: action.payload,
                error: null
            };
        case FETCH_APPLICATION_HOURS_STATS_PER_MONTH_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload
            };
        case FETCH_APPLICATION_HOURS_STATS_PER_MONTH_RESET:
            return {
                ...state,
                loading: false,
                applicationHoursStatsPerMonth: [],
                error: null
            };
        default:
            return state;
    }
};
